

export class OtSlots {

    defaultsetting = {
        "singleSelection": true,
        "allowSearchFilter": true,
        "checkBoxRequired": false,
        "closeDropDownOnSelection": true,
        "apliCall": false
    }

    bannerJson = {
        "jsonName": "banner_ot_package",
        "selector": "app-patient-layout",
        "datasource": {
          "application": "ot",
          "resource": "surgery_request",
          "query_id": "GET_BY_ID",
        }
      }

    getOTListArgs = {
        "application":"facility-management",
        "resource": "location",
        "query_id": "",
        "args": {
            "type": ""
        }
    }

    additionalSurgeries: Array<any> = [];
    otServices: Array<any> = [];
    scheduling: any;
    rescheduling: any;
    // btnDisabled: boolean = false;
    deptbtnDisabled: boolean = false;
    surgerybtnDisabled: boolean = false;
    packagebtnDisabled: boolean = false;
    specialitybtnDisabled: boolean = false;
    currentDate: any;
    checkboxvalue: string = "";
    showAcknowledge: boolean = false;
    multipleSlots: boolean = false;
    multiSlotsCheck: boolean = false;
    selectedSlot: any;
    OTId: any = "";
    OTName: any = "";
    slots: any;
    id: any;
    question: any;
    departmentList: any;
    surgeryName: any;
    multisurgeryName: any;
    surgeonSpeciality: any;
    surgeonData: any;
    patientData: any;
    datasource: any;
    department_id: any = "";
    serviceItemId: any = "";
    serviceItemName: any = "";
    surgeon_speciality_id: any = "";
    surgeon_id: any = "";
    expected_surgery_date_time: any;
    surgery_type: any;
    doctor_id:any;
    packageName: any; 
    request_type: any;
    surgery_grade_id: any;
    surgeryGradeList: any;
    surgeryGradeDurationMin: any;
    DurationMin: any;
    OtFinanceClearance:any;
    exist: any;
    serviceType: any;
    serviceType_code: any;
    kinContact: any;
    kinName: any;
    kinGender: any;
    kinRelationship: any;
    billingComponent: any = [];
    machineId: any = "";
    equipmentId: any = "";
    c_arm_Required: any;
    c_arm_name: any;
    c_arm_id: any;
    c_arm_slot_startTime: any;
    c_arm_slot_endTime: any;
    general_slots: boolean = false;
    prime_slots: boolean = false;
    slotTimingInfo: boolean = true;
    reschedule_reason: any = "";
    rescheduleReasons: any = [];
    reschedule_remarks: any = "";
    serviceDate:any
}

export class PatientDetails{
    patient_id: any;
    patientType: any;
    uhId: any;
    admissionId: any;
    payer_id: any;
    referenceId: any;
    encounter_id: any;
    finance_clearance: any;
}